import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillYoutube,
  AiFillInstagram,
} from "react-icons/ai";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Song of Songs Entertainment</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Copyright © {year}</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://www.youtube.com/channel/UC40leCWNB7cjj1JQIleSPVw"
                style={{ color: "#625a7c" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillYoutube size={33}/>
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/songofsongs_id/"
                style={{ color: "#625a7c" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram size={25}/>
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
